import {
  cancelOrder,
  sendOrder,
  changeOrderStatusToDelivered,
  // approvePayment
} from "services"
import {
  addNewShiftOrder,
  addRefundToShift,
  deleteOfflineOrder,
  editOfflineOrder,
  store,
  updateShiftQueueNumber
} from "@redux"
import delay from "./delay"

const getRequestBody = offlineOrder => {
  const orderItems =
    offlineOrder.order.items.map(item => ({
      asComboSet: false,
      optionId: item.optionId,
      foodId: item.foodId,
      quantity: item.quantity,
      systemDiscount: item.systemDiscount * item.quantity,
      specificationItemIds:
        item.specificationItems.map(si => ({
          _id: si._id,
          quantity: si.quantity,
          builderStepKey: si.builderStepKey,
          portion: si.portion
        }))
    }))

  const comboItems = []
  offlineOrder.order.combos.forEach((combo, cIndex) =>
    combo.items.forEach(comboItem =>
      comboItems.push({
        foodId: comboItem.foodId,
        optionId: comboItem.optionId,
        quantity: comboItem.quantity,
        specificationItemIds: [],
        comboSet: {
          code: combo.code,
          groupNumber: cIndex + 1,
          comboSetItemId: comboItem.comboSetItemId
        }
      })
    )
  )

  const items = [...comboItems, ...orderItems]

  const couponCodes = []

  offlineOrder.discounts.forEach(discount =>
    couponCodes.push(discount.couponCode)
  )

  offlineOrder.order.combos.forEach(combo =>
    couponCodes.push(combo.code)
  )

  const paymentType =
    offlineOrder.orderStatus === "pending" ? "cod" : "cash"

  const data = {
    items,
    isOffline: true,
    isPrinted: true,
    note: offlineOrder.note,
    branchId: offlineOrder.branchId,
    date: offlineOrder.date,
    areaName: offlineOrder.areaName,
    shiftId: offlineOrder.shiftId,
    isCod: offlineOrder.orderStatus === "pending",
    deliveryType: offlineOrder.deliveryType,
    deliveryAddress: offlineOrder.deliveryAddress,
    deliveryService: offlineOrder.deliveryService,
    paymentType
  }

  if (paymentType === "cash") {
    const cashType =
      offlineOrder.shiftOrder.cashTypes

    data["cashType"] = cashType
  }

  if (offlineOrder.deliveryType === "delivery") {
    data["address"] = offlineOrder.deliveryAddress

    if (offlineOrder.deliveryService === "snapbox") {
      data["riderQuotationId"] =
        offlineOrder.deliveryFees.quotationId
    }
  }

  if (!!couponCodes) {
    data["couponCodes"] = couponCodes
  }

  data["tableNumber"] =
    offlineOrder.deliveryType === "dineIn"
      ? offlineOrder.order.tableNumber
      : ""

  return data
}


const syncOfflineOrders = async () => {
  const offlineOrders = store.getState().offlineOrders

  if (offlineOrders.length === 0) return

  const ordersCreatedInOfflineMode = []

  const onlineOrdersChangedInOfflineMode = []

  offlineOrders.forEach(offlineOrder => {
    !!offlineOrder.onlineOrderId
      ? onlineOrdersChangedInOfflineMode.push(offlineOrder)
      : ordersCreatedInOfflineMode.push(offlineOrder)
  })

  for (const orderCreatedInOfflineMode of ordersCreatedInOfflineMode) {
    const requestBody =
      getRequestBody(orderCreatedInOfflineMode)

    const accountId =
      orderCreatedInOfflineMode.accountId

    let syncedOrderId =
      orderCreatedInOfflineMode.syncedOrderId

    try {
      if (!syncedOrderId) {
        const { order } =
          await sendOrder(requestBody, { accountId })

        syncedOrderId = order._id

        store.dispatch(
          editOfflineOrder(
            orderCreatedInOfflineMode.offlineOrderId,
            { syncedOrderId: order._id }
          )
        )

        if (order.orderStatus === "paid") {
          const tempOrderId =
            orderCreatedInOfflineMode.onlineOrderId ||
            orderCreatedInOfflineMode.offlineOrderId

          store.dispatch(
            updateShiftQueueNumber(tempOrderId, order._id)
          )

          store.dispatch(
            addNewShiftOrder(
              orderCreatedInOfflineMode.shiftOrder
            )
          )
        }
      }

      if (orderCreatedInOfflineMode.orderStatus === "canceled") {
        await cancelOrder(
          syncedOrderId,
          {
            refundType: orderCreatedInOfflineMode.refundType,
            cancelReasons: orderCreatedInOfflineMode.cancelReasons
          }
        )

        const totalTaxes =
          orderCreatedInOfflineMode.shiftOrder.taxes +
          orderCreatedInOfflineMode.shiftOrder.charges

        store.dispatch(
          addRefundToShift(
            orderCreatedInOfflineMode.total,
            totalTaxes,
            orderCreatedInOfflineMode.shiftOrder.discounts
          )
        )
      }

      if (orderCreatedInOfflineMode.orderStatus === "delivered") {
        await changeOrderStatusToDelivered(syncedOrderId)
      }

      store.dispatch(
        deleteOfflineOrder(
          orderCreatedInOfflineMode.offlineOrderId
        )
      )
    } catch (err) {
      console.log(err)
    }

    await delay(2000)
  }
}

export default syncOfflineOrders
